<template>
  <b-card class="">
    <div class="table-responsive">
      <div class="table align-middle table-nowrap">
        <b-table
          :items="value"
          :fields="tblFields"
          responsive="sm"
        >
          <template #cell(action)="data">
            <i class="mdi mdi-alert-circle text-danger" v-if="(data.item.auditStatus==null||data.item.auditStatus == 'denied') && data.item.contractStatus != 'contract_cancelled'"></i>
          </template>
          <template #cell(storeName)="data">
            <span class="text-capitalize text-primary c-pointer" @click="view(data.item)">{{data.item.storeName}}</span>
          </template>
          <template #cell(duration)="data">
            {{data.item.duration}} Months
          </template>
          <template #cell(collateral)="data">
            <span class="text-capitalize">{{data.item.type}}</span>
          </template>
          <template #cell(size)="data">
            {{data.item.dimension}}
          </template>
          <template #cell(collateralStatus)="data">
            <div class="text-center">{{data.item.collateralStatus}}</div>
          </template>
          <template #cell(totalBalance)="data">
            <div class="ta-right">₱ {{data.item.totalBalance | toCurrency}}</div>
          </template>
          <template #cell(totalRelease)="data">
            <div class="ta-right">₱ {{data.item.totalRelease | toCurrency}}</div>
          </template>
          <template #cell(status)="data">
            {{data.item.contractStatus}}
          </template>
        </b-table>
      </div>
    </div>
  </b-card>
</template>
<script>
import {layoutMethods, layoutComputed} from "@/state/helpers";

export default {
  props: ['value'],
  components: {
  },
  computed: {
    ...layoutComputed
  },
  methods: {
    ...layoutMethods,
    view(item){
      this.$emit("viewFullDetails", item);
    }
  },
  data() {
    return {
      tblFields: [
        {key: 'action', label:"", sortable: false},
        {key: 'storeName', sortable: false},
        {key: 'duration', sortable: false},
        {key: 'collateral', sortable: false},
        {key: 'size', sortable: false},
        {key: 'collateralStatus', sortable: false},
        {key: 'totalBalance', sortable: false},
        {key: 'totalRelease', sortable: false},
        {key: 'status', sortable: false},
      ],
    };
  },
  mounted(){
    // this.$toast.showToast('success', "Successful test", "Your top-up was successfully added to you wallet.");
  }
};
</script>
<style>
</style>